import React, { useCallback, useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg';
import { getSelectedUserPlan } from '../../server/server';
import PlanProgress from './components/PlanProgress';
import PlanOverview from './components/PlanOverview';

function UserPlanModal({ isOpen, closeModal, userProfile }: { isOpen: boolean; closeModal: () => void; userProfile: any }) {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [plan, setPlan] = useState<any>(null);

	const fetchUserPlan = useCallback(async () => {
		if (!userProfile?.id) return;

		setLoading(true);
		setError(null);

		try {
			const resp = await getSelectedUserPlan(userProfile.id);

			if (resp.status === 200) {
				setPlan(resp.data);
			} else {
				setError('Failed to fetch user plan');
			}
		} catch (err) {
			const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred';
			setError(errorMessage);
		} finally {
			setLoading(false);
		}
	}, [userProfile?.id]);

	useEffect(() => {
		if (isOpen) {
			fetchUserPlan();
		}
	}, [isOpen, fetchUserPlan]);

	return (
		<ReactModal
			isOpen={isOpen}
			onAfterOpen={() => {}}
			onRequestClose={closeModal}
			style={{
				overlay: {
					zIndex: 7,
					background: '#00000045',
				},
				content: {
					padding: 0,
					paddingTop: 30,
					paddingBottom: 30,
					opacity: 1,
					width: 600,
					margin: 'auto',
					backgroundColor: 'transparent',
					maxHeight: '100vh',
					border: 'none',
					boxShadow: 'none',
					overflow: 'auto',
				},
			}}
			className={'scrollbar-display-none'}
		>
			<div className='student-info-modal  ' style={{ paddingLeft: 20, paddingRight: 20 }}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<div className='close-modal-icon ' onClick={() => closeModal()}>
						<CloseModalIcon />
					</div>
				</div>
				{loading && <p>Loading...</p>}
				{error && <p style={{ color: 'red' }}>{error}</p>}
				{plan && (
					<div>
						<PlanProgress completed={plan.completedContent} total={plan.requiredContent} />
						<PlanOverview plan={plan} onOpenPlan={() => console.log('Open full plan')} />
					</div>
				)}
			</div>
		</ReactModal>
	);
}

export default UserPlanModal;
